import { NgModule } from '@angular/core';

import { ScorecardModule } from '@galaxy/snapshot';
import { SideDrawerModule } from '../side-drawer/side-drawer.module';
import { SnapshotDynamicScorecardComponent } from './dynamic.component';
import { SnapshotScorecardComponent } from './snapshot-scorecard.component';
import { SnapshotDynamicComponentDirective } from './snapshot.directive';

import { TranslateModule } from '@ngx-translate/core';
import { DynamicOpenCloseTemplateRefService } from '../side-drawer/dynamic-open-close-template-ref.service';

import { SnapshotScorecardService } from './snapshot-scorecard.service';

@NgModule({
  imports: [ScorecardModule, SideDrawerModule, TranslateModule],
  exports: [SnapshotScorecardComponent, SnapshotDynamicScorecardComponent, SnapshotDynamicComponentDirective],
  declarations: [SnapshotScorecardComponent, SnapshotDynamicScorecardComponent, SnapshotDynamicComponentDirective],
  providers: [DynamicOpenCloseTemplateRefService, SnapshotScorecardService],
})
export class SnapshotScorecardModule {}
